export const GET_POSTS_CARDS_GQL = `
  query getPostsCard($first: Int!) {
    posts(first: $first, where: { orderby: { field: DATE, order: DESC } }) {
      nodes {
        id
        title
        slug
        excerpt
        date
        views
        featuredImage {
          node {
            sourceUrl
            altText
          }
        }
        categories {
          nodes {
            id
            name 
          }
        }
      }
    }
  }
`;

export const GET_ALL_POSTS_GQL = `
  query getAllPosts {
    posts(first: 500, where: { orderby: { field: DATE, order: DESC } }) {
      nodes {
        id
        title
        slug
        excerpt
        date
        views
        featuredImage {
          node {
            sourceUrl
            altText
          }
        }
        categories {
          nodes {
            id
            name 
          }
        }
      }
    }
  }
`;
